import React from 'react';
import { useLanguage, Language } from '../contexts/LanguageContext';
type NoticeContent = {
  before: string;
  linkLabel: string;
  after: string;
};
const NOTICES: Record<Language, NoticeContent> = {
  en: {
    before: 'Noor Passport Services is a private company — not affiliated with, endorsed by, or acting on behalf of the U.S. government, the U.S. Department of State, or any federal agency. You can apply for or renew a U.S. passport directly at ',
    linkLabel: 'travel.state.gov',
    after: ", paying only the government's own fees."
  },
  es: {
    before: 'Noor Passport Services es una empresa privada — no está afiliada, ni respaldada, ni actúa en nombre del gobierno de EE. UU., el Departamento de Estado ni ninguna agencia federal. Puede solicitar o renovar su pasaporte directamente en ',
    linkLabel: 'travel.state.gov',
    after: ' pagando solo las tarifas oficiales del gobierno.'
  },
  ht: {
    before: 'Noor Passport Services se yon konpayi prive — li pa afilye ak, ni andose pa, ni aji nan non gouvènman ameriken an, Depatman Deta Etazini, oswa okenn ajans federal. Ou ka aplike pou oswa renouvle paspò ameriken w lan dirèkteman sou ',
    linkLabel: 'travel.state.gov',
    after: ', w ap peye sèlman frè ofisyèl gouvènman an.'
  },
  vi: {
    before: 'Noor Passport Services là một công ty tư nhân — không liên kết, không được chứng thực, và không hoạt động thay mặt cho chính phủ Hoa Kỳ, Bộ Ngoại giao Hoa Kỳ, hay bất kỳ cơ quan liên bang nào. Quý vị có thể xin cấp hoặc gia hạn hộ chiếu Hoa Kỳ trực tiếp tại ',
    linkLabel: 'travel.state.gov',
    after: ', chỉ phải trả các khoản phí chính thức của chính phủ.'
  }
};
export function NoticeBar() {
  const {
    language
  } = useLanguage();
  const notice = NOTICES[language];
  return <div className="w-full text-white" style={{
    backgroundColor: '#16243F'
  }} role="region" aria-label="Important disclosure" data-id="element-316" data-mp="1xd0nyowop18v">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-3.5" data-id="element-317" data-mp="1sfqzpcl16vmm">
        <p className="text-center leading-relaxed" style={{
        fontSize: '15px'
      }} data-id="element-318" data-mp="1tvcukpw0dwy8">
          {notice.before}
          <a href="https://travel.state.gov" target="_blank" rel="noopener noreferrer" className="font-semibold underline underline-offset-2 decoration-2 hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#16243F] focus:ring-brand-accent rounded-sm" style={{
          color: '#B08A2E'
        }} data-id="element-319" data-mp="1kun7qboq7gwn">
            {notice.linkLabel}
          </a>
          {notice.after}
        </p>
      </div>
    </div>;
}